import { type ReactNode } from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  Text,
  Link,
} from '@backstage/ui';

type CopilotBudgetCardProps = {
  children: ReactNode;
};

export const CopilotBudgetCard = ({ children }: CopilotBudgetCardProps) => {
  return (
    <Card style={{ border: '1px solid var(--bui-border-1)' }}>
      <CardHeader>
        <Flex align="center" justify="between" gap="2">
          <Flex gap="1">
            <Text variant="title-x-small">GitHub</Text>
            <Text variant="title-x-small" weight="bold">
              Copilot
            </Text>
          </Flex>
          <Link href="/github-statistics/account" variant="body-small">
            Show model details
          </Link>
        </Flex>
      </CardHeader>
      <CardBody>{children}</CardBody>
      <CardFooter>
        <Text variant="body-small" color="secondary">
          Budget resets monthly
        </Text>
      </CardFooter>
    </Card>
  );
};
